import React, { useEffect, useState } from "react";
import Navbar from "@/components/campus/Navbar";
import Footer from "@/components/campus/Footer";
import { Trophy, Star } from "lucide-react";
import { api } from "@/lib/api";

export default function Leaderboard() {
  const [items, setItems] = useState([]);
  useEffect(()=>{ api.leaderboard().then(setItems).catch(()=>{}); }, []);
  const top3 = items.slice(0,3); const rest = items.slice(3,20);
  return (
    <div className="min-h-screen bg-[#0F172A] text-white">
      <Navbar/>
      <section className="pt-28 px-6 pb-20 max-w-5xl mx-auto">
        <div className="text-center">
          <Trophy className="mx-auto text-amber-400 mb-3" size={42}/>
          <h1 className="font-display text-4xl md:text-5xl font-bold">Top Campus Ambassadors</h1>
          <p className="text-slate-400 mt-3">Ranked by total conversations and student ratings</p>
        </div>

        {top3.length>0 && (
          <div className="grid md:grid-cols-3 gap-4 mt-12">
            {top3.map((a,i)=>{
              const med = ["🥇","🥈","🥉"][i];
              return (
                <div key={a.user_id} className={`glass rounded-2xl p-6 text-center ${i===0?"md:order-2 md:-translate-y-4 border-amber-400/50":i===1?"md:order-1":"md:order-3"}`}>
                  <div className="text-4xl">{med}</div>
                  <div className="w-16 h-16 mx-auto rounded-full bg-gradient-to-br from-[#2563EB] to-[#1E3A8A] flex items-center justify-center font-bold mt-3">{a.full_name?.split(" ").map(w=>w[0]).slice(0,2).join("")}</div>
                  <div className="font-display font-bold mt-2">{a.full_name}</div>
                  <div className="text-xs text-slate-400">{a.college_name} · {a.course} · {a.year}</div>
                  <div className="flex items-center justify-center gap-3 mt-3 text-sm"><span className="flex items-center gap-1 text-amber-400"><Star size={14} className="fill-amber-400"/>{a.rating_avg}</span><span className="text-slate-400">· {a.conversations} convos</span></div>
                </div>
              );
            })}
          </div>
        )}

        {rest.length>0 && (
          <div className="glass rounded-2xl mt-10 overflow-hidden">
            <table className="w-full text-sm"><thead className="bg-white/5"><tr><th className="px-4 py-3 text-left">#</th><th className="text-left">Name</th><th className="text-left">College</th><th>Calls</th><th>Rating</th></tr></thead>
              <tbody>{rest.map((a,i)=>(
                <tr key={a.user_id} className="border-t border-white/5"><td className="px-4 py-3 text-slate-400">{i+4}</td><td>{a.full_name}</td><td className="text-slate-300">{a.college_name}</td><td className="text-center">{a.total_calls}</td><td className="text-center text-amber-400">⭐ {a.rating_avg}</td></tr>
              ))}</tbody>
            </table>
          </div>
        )}
        {items.length===0 && <div className="text-center text-slate-400 mt-12">No ambassadors yet. Be the first!</div>}
      </section>
      <Footer/>
    </div>
  );
}
